<mat-card class="example-card shadow" style="margin: 15vh 10vw">
   <mat-card-content>
      <div id="logo-wrapper">
         <img id="logo" src="../../assets/img/logo-600.png" alt="" />
      </div>
      <h2 style="color: var(--dark-purple); text-align: center"
         ><b [innerHTML]="bilingual('home.join')"></b
      ></h2>
      <b>{{ inLang('home.fill-form', 'hu') }}</b>
      <br /><br />
      <b class="en-text">{{ inLang('home.fill-form', 'en') }}</b>
      <br /><br />
      <form [formGroup]="form">
         <div class="row">
            <mat-form-field appearance="fill">
               <mat-label class="label-color">{{ bilingual('data.dateOfBirth') }}</mat-label>
               <input
                  matInput
                  [matDatepicker]="picker"
                  formControlName="dateOfBirth"
                  placeholder="19971231"
                  (change)="dateOfBirtOnChange($event)"
               />
               <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
               <mat-datepicker
                  display="anchored"
                  startView="year"
                  [startAt]="startDate"
                  [touchUi]="touchUi$ | async"
                  #picker
               ></mat-datepicker>
            </mat-form-field>
            <mat-form-field appearance="fill">
               <mat-label class="label-color">{{ bilingual('data.taxNumber') }}</mat-label>
               <input
                  matInput
                  formControlName="taxNumber"
                  placeholder="8123456789"
                  #taxNumberInput="matInput"
                  maxlength="10"
               />
               <mat-error *ngIf="form.controls.taxNumber.hasError('leadingEight')">
                  {{ bilingual('data.errors.taxNumber.leadingEight') }}
               </mat-error>
               <mat-error *ngIf="form.controls.taxNumber.hasError('badDays')">
                  {{ bilingual('data.errors.taxNumber.badDays') }}
               </mat-error>
               <mat-error *ngIf="form.controls.taxNumber.hasError('badCheckSum')">
                  {{ bilingual('data.errors.taxNumber.badCheckSum') }}
               </mat-error>
               <mat-error *ngIf="form.controls.taxNumber.hasError('length')">
                  {{ bilingual('data.errors.taxNumber.badLength') }}
               </mat-error>
            </mat-form-field>
         </div>
      </form>
      <br />
      <!-- each button is intentionally written in its own language, regardless of the UI language -->
      <div id="lang-buttons">
         <button
            class="lang-button"
            mat-flat-button
            color="secondary"
            (click)="onNext('hu')"
            [disabled]="form.invalid"
         >
            <img class="flag" src="../../assets/img/flag-hu.svg" alt="HUN" />
            <span class="lang-button-text">
               <b>Tovább</b>
               <small>Magyar nyelvű kommunikációt kérek</small>
            </span>
         </button>
         <button
            class="lang-button lang-button-en"
            mat-flat-button
            color="secondary"
            (click)="onNext('en')"
            [disabled]="form.invalid"
         >
            <img class="flag" src="../../assets/img/flag-en.svg" alt="ENG" />
            <span class="lang-button-text">
               <b>Continue</b>
               <small>I want to receive communication in English</small>
               <small>If you don’t speak Hungarian, please select this option</small>
            </span>
         </button>
      </div>
   </mat-card-content>
</mat-card>
